import {palette} from "./palette";

export type InputType = {
    inputWrapper: any,
    input: any,
    inputActiveClass: any,
    inputErrorClass: any,
};

export const InputStyles: InputType = {
    inputWrapper: {
        position: 'relative',
        background: palette.dark_grey,
        borderRadius: '.5rem',
        boxSizing: 'border-box',
        display: 'flex',
        fontFamily: 'SF Pro Text',
        alignItems: 'center',
        height: '56px',
        maxWidth: '560px',
        margin: '0 auto',
        padding: '16px',
    },
    input: {
        border: 'none',
        outline: 'none',
        background: 'none',
        all: 'unset',
        display: 'block',
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        borderRadius: '.5rem',
        color: palette.white,
        marginTop: '20px',
        caretColor: palette.primary,

        '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
        }
    },
    inputActiveClass: {
        backgroundImage: `linear-gradient(${palette.primary}, ${palette.primary})`,
        backgroundPosition: 'bottom 0 center',
        backgroundSize: '100% 2px',
        backgroundRepeat: 'no-repeat',
    },
    inputErrorClass: {
        backgroundImage: `linear-gradient(${palette.error}, ${palette.error})`,
        backgroundPosition: 'bottom 0 center',
        backgroundSize: '100% 2px',
        backgroundRepeat: 'no-repeat',
    },
};
